import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { StripeService } from 'ngx-stripe';
import { NotificationService } from '../../shared/notification.service';
import { AccountService } from '../../shared/services/account.service';
import { PaymentService } from '../../shared/services/payment.service';
import { ActiveCard, PaymentParams, User } from '../account.model';

@Component({
  selector: 'cc-recharge-confirmation',
  templateUrl: './recharge-confirmation.component.html',
  styleUrls: ['./recharge-confirmation.component.scss']
})
export class RechargeConfirmationComponent implements OnInit, OnDestroy {
  public activeCard: ActiveCard;
  public paymentParams: PaymentParams;
  public piid: string;
  public currency: string;
  public spinner: boolean;
  public user: User;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private stripeService: StripeService,
    private notificationService: NotificationService,
    private accountService: AccountService,
    private router: Router,
    public paymentService: PaymentService
  ) {}

  ngOnInit() {
    this.activeCard = {
      brand: '',
      cardExpired: false,
      expMonth: null,
      expYear: null,
      last4Digits: ''
    };
    this.piid = this.route.snapshot.queryParams['piid'];
    this.accountService.getCard().subscribe((response: ActiveCard) => {
      this.activeCard = response;
    });

    this.accountService.getPaymentStatus(this.piid).subscribe((response: PaymentParams) => {
      this.paymentParams = response;
    });

    this.paymentService.spinnerActivate.subscribe(activator => {
      this.spinner = activator;
    });

    this.accountService.getUser().subscribe((user: User) => {
      this.user = user;
    });
  }

  onConfirm(event) {
    if (event) {
      this.recharge();
    }
  }

  recharge() {
    this.paymentService.checkPaymentStatus(() => this.accountService.getPaymentStatus(this.piid), '/account');
  }

  ngOnDestroy() {
    this.notificationService.dismiss();
  }
}
